<template lang="pug">
.views-container
  gb-side-menu
  .loading-area(v-if="fetchLoading")
    vue-loading(
      type='spin'
      color="#F7CA18"
      :size="{ width: '60px', height: '60px' }"
    )
  .content-area(v-else)
    h3 {{schoolName}} 保育士一覧
    member-list-nursery(
      :memberList="memberList"
      @deleteClicked="deleteModal"
      @editClicked="editModal"
    )
</template>

<script>
import util from '@/api/util'
import { VueLoading } from 'vue-loading-template'
import LocalDataUtil from '@/util/LocalDataUtil.js'

import MemberListNursery from '@/components/organisms/MemberListNursery.vue'
import EditCard from '@/components/organisms/EditCard.vue'
import GbSideMenu from '@/components/organisms/GbSideMenu.vue'
import GbButton from '@/components/atoms/GbButton.vue'
import GbInput from '@/components/atoms/GbInput.vue'
import GbMask from '@/components/atoms/GbMask.vue'
import GbCard from '@/components/atoms/GbCard.vue'

export default {
  components: {
    VueLoading,
    MemberListNursery,
    EditCard,
    GbSideMenu,
    GbButton,
    GbInput,
    GbMask,
    GbCard
  },
  data () {
    return {
      fetchLoading: true,
      memberList: []
    }
  },
  beforeMount: async function () {
    const isMaintenance = (await util.checkMaintenance({type: 'admin'})).data.data.is_maintenance
    if (isMaintenance) {
      this.$swal.fire({
        html: `現在メンテナンス中です`
      }).then(() => {
        this.$router.push({ name: 'Maintenance' })
      })
    } else {
      util.createMethod('COG', 'checkSessionExpired', null)
        .then(response => {
          if (response) {
            this.$router.push({ name: 'SignIn' })
          } else {
            this.fetchNurseList()
          }
        })
    }
  },
  methods: {
    async fetchNurseList () {
      const Authority = (await util.createMethod('APPSYNC', 'fetchAdminMast', {sub: LocalDataUtil.getSub()}))
      if (!Authority.getChildminder) {
        this.$swal.fire({
          text: `保育士情報の閲覧権限がありません`
        }).then(() => {
          this.$router.push({ name: 'SchoolList' })
        })
        return
      }
      try {
        const CCS_REQUEST_VALUE = {
          session: LocalDataUtil.getCcsSession(),
          status: 1
        }
        const Response = (await util.createMethod('CCS', 'ccsFetchNurseList', CCS_REQUEST_VALUE, this.$route.params.nurseryCode)).data.data
        this.memberList = Response
        this.fetchLoading = false
      } catch (error) {
        let dialog
        if (error.data.error) dialog = error.data.error
        else dialog = `エラーが発生しました<br>時間をおいてもう一度お試しください`
        if (error.data.error) {
          this.$swal.fire({
            text: `${dialog}`
          }).then(() => {
            this.fetchLoading = false
          })
        }
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../stylus/main.styl'
.container
  width 100vw
  height 100vh
  display flex
  flex-direction row
.col-group
  display flex
  flex-direction column
.disable-card
  width 680px
  height 400px
  display flex
  flex-direction column
  justify-content space-between
.gb-card-cancel
  background-color #fff
  border-radius 2px
  padding-top 0
  padding-right 0
  display flex
  align-items flex-end
.logout
  margin 0 auto 50px
.cancel-box
  width 50px
  height 50px
  border-bottom 1px solid #000
  border-left 1px solid #000
  display grid
  align-items center
.cancel-bottom
  font-size 30px
  text-align center
  font-weight 300
</style>



// WEBPACK FOOTER //
// src/views/NurseList.vue